import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, SharedService } from '.';
import { CONTROLLERS, ENDPOINTS } from '../constants';
import {
  AccountDetails,
  AutoSignInMemberCommand,
  CheckEmailExistMemberCommand,
  CreateMemberCommand,
  DeleteMemberCommand,
  InviteUser,
  LockedAccountSecurityQuestion,
  PaginationRequestCommand,
  PayNowPracticeAccountDetails,
  ResendInviteRequest,
  ResetPasswordMemberCommand,
  Response,
  SendOtpForUpdateEmailReq,
  SignInMemberCommand,
  SignUpMemberCommand,
  UpdateAccountDetailsCommand,
  UpdateEmailReq,
  UpdateMemberCommand,
  User,
  VerifyLockedMemberSecurityAnswersCommand,
} from '../models';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  private api: string = CONTROLLERS.MEMBERS;

  constructor(
    private apiService: ApiService,
    private sharedService: SharedService
  ) { }

  signUp(body: SignUpMemberCommand): Observable<Response<boolean>> {
    return this.apiService.post(`${this.api}/${ENDPOINTS.MEMBER.SIGNUP}`, body);
  }

  signIn(body: SignInMemberCommand): Observable<Response<User>> {
    return this.apiService.post(`${this.api}/${ENDPOINTS.MEMBER.SIGNIN}`, body);
  }
  autoSignIn(practiceId?: number): Observable<Response<User>> {
    let url = `${this.api}/${ENDPOINTS.MEMBER.AUTO_SIGNIN}`;
    if (practiceId) {
      url += `?practiceId=${practiceId}`;
    }
    return this.apiService.get(url);
  }
  verifyOTP(email: string, otp: string, practiceId: number): Observable<Response<any>> {
    return this.apiService.post(`${this.api}/${ENDPOINTS.MEMBER.VERIFY_OTP}`, {
      email,
      otp,
      practiceId
    });
  }

  resendOTP(email: string): Observable<Response<any>> {
    return this.apiService.post(`${this.api}/${ENDPOINTS.MEMBER.RESEND_OTP}`, {
      email,
    });
  }

  getAccountDetails(): Observable<Response<AccountDetails>> {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.MEMBER.GET_ACCOUNT_DETAILS}`
    );
  }

  getAccountDetailsForPayNow(
    Id: string
  ): Observable<Response<PayNowPracticeAccountDetails>> {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.MEMBER.GET_ACCOUNT_DETAILS_FOR_PAY_NOW}/${Id}`
    );
  }

  updateAccountDetails(
    memberId: string,
    accountDetails: UpdateAccountDetailsCommand
  ): Observable<Response<any>> {
    return this.apiService.put(
      memberId,
      `${this.api}/${ENDPOINTS.MEMBER.UPDATE_ACCOUNT_DETAILS}`,
      accountDetails
    );
  }

  sendResetPasswordLink(email: string): Observable<Response<boolean>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.MEMBER.FORGOT_PASSWORD}/${email}`,
      null
    );
  }

  resetPassword(
    body: ResetPasswordMemberCommand
  ): Observable<Response<boolean>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.MEMBER.RESET_PASSWORD}`,
      body
    );
  }

  changePassword(body: {
    oldPassword: string;
    newPassword: string;
  }): Observable<Response<boolean>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.MEMBER.CHANGE_PASSWORD}`,
      body
    );
  }

  verifyPassword(body: { password: string }): Observable<Response<boolean>> {
    return this.apiService.post(`${this.api}/${ENDPOINTS.MEMBER.VERIFY_PASSWORD}`, body);
  }

  checkEmailExist(
    body: CheckEmailExistMemberCommand
  ): Observable<Response<boolean>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.MEMBER.CHECK_EMAIL_EXIST}`,
      body
    );
  }

  getMemberEmail(token: string) {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.MEMBER.GET_MEMBER_EMAIL}/${token}`
    );
  }

  getMembersList(paginationRequestCommand: PaginationRequestCommand) {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.MEMBER.GET_MEMBERS_LIST}`,
      paginationRequestCommand
    );
  }
  getRequestedMembersList(paginationRequestCommand: PaginationRequestCommand) {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.MEMBER.GET_REQUESTED_MEMBERS_LIST}`,
      paginationRequestCommand
    );
  }
  addMember(body: CreateMemberCommand): Observable<Response<boolean>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.MEMBER.CREATE_MEMBER}`,
      body
    );
  }

  updateMember(body: UpdateMemberCommand): Observable<Response<boolean>> {
    return this.apiService.put(
      '',
      `${this.api}/${ENDPOINTS.MEMBER.UPDATE_MEMBER}`,
      body
    );
  }
  deleteMember(req: DeleteMemberCommand): Observable<Response<boolean>> {
     return this.apiService.put(
      '',
      `${this.api}/${ENDPOINTS.MEMBER.DELETE_MEMBER}`,
      req
    );
  }
  updateMemberProfile(body: UpdateMemberCommand): Observable<Response<boolean>> {
    return this.apiService.put(
      '',
      `${this.api}/${ENDPOINTS.MEMBER.UPDATE_MEMBER_PROFILE}`,
      body
    );
  }

  getMemberById(memberId: number) {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.MEMBER.GET_MEMBER_By_ID}/${memberId}`
    );
  }

  getMemberDropdownByCustomer() {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.MEMBER.GET_MEMBER_DROPDOWN_BY_CUSTOMER}`
    );
  }

  inviteMember(body: InviteUser): Observable<Response<boolean>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.MEMBER.INVITE_MEMBER}`,
      body
    );
  }

  updateInviteMember(body: InviteUser): Observable<Response<boolean>> {
    return this.apiService.put(
      '',
      `${this.api}/${ENDPOINTS.MEMBER.UPDATE_INVITE_MEMBER}`,
      body
    );
  }

  sendOTP(data:SendOtpForUpdateEmailReq): Observable<Response<any>> {
     return this.apiService.post(
      `${this.api}/${ENDPOINTS.MEMBER.SEND_OTP}`,
      data
    );
  }
  verifyUpdateEmailOTP(email: string, otp: string, practiceId: number): Observable<Response<any>> {
    return this.apiService.post(`${this.api}/${ENDPOINTS.MEMBER.VERIFY_UPADTE_EMAIL_OTP}`, {
      email,
      otp,
      practiceId
    });
  }
    updateAuthorizedEmail(data: UpdateEmailReq): Observable<Response<boolean>> {
      return this.apiService.put(
        '',
        `${this.api}/${ENDPOINTS.MEMBER.UPDATE_EMAIL}`,
        data
      );
    }
  signOut(): Observable<Response<boolean>> {
    return this.apiService.post(`${this.api}/${ENDPOINTS.MEMBER.LOGOUT}`, { });
  }

  getLockedSecurityQuestions(email: string): Observable<Response<LockedAccountSecurityQuestion[]>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.MEMBER.GET_LOCKED_SECURITY_QUESTIONS}`,
      { email }
    );
  }

  verifyLockedSecurityAnswers(
    body: VerifyLockedMemberSecurityAnswersCommand
  ): Observable<Response<string>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.MEMBER.VERIFY_LOCKED_SECURITY_ANSWERS}`,
      body
    );
  }

  getForgotPasswordSecurityQuestions(email: string): Observable<Response<LockedAccountSecurityQuestion[]>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.MEMBER.GET_FORGOT_PASSWORD_SECURITY_QUESTIONS}`,
      { email }
    );
  }

  verifyForgotPasswordSecurityAnswers(
    body: VerifyLockedMemberSecurityAnswersCommand
  ): Observable<Response<boolean>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.MEMBER.VERIFY_FORGOT_PASSWORD_SECURITY_ANSWERS}`,
      body
    );
  }
  verifyPracticeInviteToken(token: string) {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.MEMBER.VERIFY_PRACTICE_INVITE_TOKEN}/${token}`
    );
  }
  deleteInvitation(token: string) {
    return this.apiService.delete(
      token,
      `${this.api}/${ENDPOINTS.MEMBER.DELETE_INVITATION}`
    );
  }
    resendInvitation(body: ResendInviteRequest) {
      return this.apiService.post(
      `${this.api}/${ENDPOINTS.MEMBER.RESEND_INVITATION}`,
      body
    );
  }
}
